import { useTranslation } from "react-i18next";
import GenericComponent from "../../utils/genericComponent/GenericComponent";
import { ReactComponent as Image } from "../../../assets/img/mail-illustration.svg";

const VideoIdentificationUnavailable = () => {
  const { t } = useTranslation();

  return (
    <GenericComponent
      ImageSrc={Image}
      pageTitle={t`screens.videoIdUnavailable.pageTitle`}
      pageSubtitle={t`screens.videoIdUnavailable.pageSubtitle`}
      transComponent={{ br: <br />, b: <b>{}</b> }}
      buttonLabel={t`screens.videoIdUnavailable.backBtn`}
      onClickCallback={() => (window.location.href = "/cb-thirdpillar/")}
    />
  );
};

export default VideoIdentificationUnavailable;
